var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "savingProject" }, [
    _c("svg", { attrs: { viewBox: "0 0 32 32", width: "64", height: "64" } }, [
      _c("circle", {
        staticClass: "animation-spinner",
        attrs: { id: "spinner", cx: "16", cy: "16", r: "14", fill: "none" },
      }),
    ]),
    _vm._v(" "),
    _c("span", { staticClass: "textNode mainMessage" }, [
      _vm._v(
        "\n\t\t" + _vm._s(_vm.$t("views.savingProject.mainMessage")) + "\n\t"
      ),
    ]),
    _vm._v(" "),
    _c("span", { staticClass: "textNode subMessage" }, [
      _vm._v(
        "\n\t\t" + _vm._s(_vm.$t("views.savingProject.subMessage")) + "\n\t"
      ),
    ]),
    _vm._v(" "),
    _vm.hasCancel
      ? _c(
          "span",
          { staticClass: "textNode cancel", on: { click: _vm.onCancel } },
          [
            _vm._v(
              "\n\t\t" + _vm._s(_vm.$t("views.savingProject.cancel")) + "\n\t"
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }